const zipCodeInputFormatter = (
  zipCodeInput?: string,
): string => {
  if (!zipCodeInput) {
    return '';
  }

  // Remove all non-digit characters
  const digitsOnly = zipCodeInput.replace(/[^\d]/g, '');

  // Limit to exactly 5 digits
  return digitsOnly.slice(0, 5);
};

export default zipCodeInputFormatter;
